<template>

<div class='row'>
    <loading-div v-if='!isReady'></loading-div>

    <div v-if='isReady' class="col-12">
        
        <!-- Tabs -->
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <ul class="nav tab-nav mt-0 mb-4 mb-md-5">
  
                    <li @click='selectRole(r)' v-for='r in roles' class="nav-item">
                        <span :class="['nav-link', { active : r.id == role.id }]">
                            {{ r.name }}
                        </span>
                    </li>

                </ul>
            </div>
        </div>

        <!-- Listing -->
        <div class="row">
            <div class="col-lg-4 col-sm-6 mb-4 mb-md-5" v-for='(c,i) in contractors'>
                <div class="list-item list-contractors shadow-lg h-100 project-item pb-0 d-flex flex-column justify-content-between">
                    <div class="list-content">
                        <!-- Header Profile Image -->
                        <div class="list-img">
                            <a :href="'/contractors/' + c.id">
                                <img class="img-responsive" 
                                     :src="c.cover_thumb ? c.cover_thumb : '/resources/images/default-list-item-img.jpg'" 
                                     :alt="c.name + ' ' + c.last_name">
                            </a>
                        </div>

                        <!-- User Image -->
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">  
                                <a :href="'/contractors/' + c.id">      
                                    <span class="user-profile-pic user-profile-list">
                                        <img :src="c.avatar ? c.avatar : '/resources/images/static/user-pic.jpg'" 
                                             :alt="c.name + ' ' + c.last_name">
                                    </span>
                                </a>
                            </div>
                        </div>


                        <!-- List Info -->
                        <div class="list-info pl-4 pr-4 pb-1 mt-1">
                            <h4 class="text-center">
                                <a :href="'/contractors/' + c.id">
                                    {{ c.brand ? c.brand : c.name }}
                                </a>
                            </h4>

                            <div v-if='role' class="text text-tiny text-center">
                                {{ role.name }}  
                            </div>

                            <div class="d-flex justify-content-center mt-2">
                                <user-rating :rating='c.rating'></user-rating>
                            </div>
                        </div>
                    </div>

                    <div class="text-center pt-2 pb-3 mt-4 mr-3 ml-3 border-top">
                        <a :href="'/contractors/' + c.id" class="link">
                            Виж профила
                            <span class="icon icon-chevron-right icon-after"></span>
                        </a>
                    </div>

                </div>
            </div>
        </div>

        <!-- Load more button -->
        <div v-if='contractors.length < total' class="row">
            <div class="col-12 d-flex justify-content-center">
                <button class="btn btn-outline-primary">
                    <span class="icon icon-refresh-cw"></span>
                    Зареждане на още
                </button>
            </div>
        </div>
        
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {

            return {
                isReady : false,

                total : 0,
                role  : 0,
                roles : [],

                contractors : [],


            }

        },

        methods : {

            getData() {
                var me = this;

                var data =  { skip : me.shouldConcat ? this.contractors.length : 0 };

                if( this.role ) {
                
                    //Role selected
                    data.r = this.role.id;
                
                } else {
                    
                    //Default - first role
                    data.r = 0;

                }

                me.isReady = false;

                me.ajax.call('cnt:gtc', data, (r) => {
                    
                    if( r.status == 'success' ) {

                        //On load more - concat, otherwise reset
                        if( me.shouldConcat ) {
                            me.contractors = me.contractors.concat(r.data.c);
                        } else {
                            me.contractors = r.data.c;
                        }

                        me.total       = r.data.t;
                        me.roles       = r.data.r;

                        if( me.role == 0 ) {
                            me.role = me.roles[0];
                        }

                        me.isReady = true;
                    }

                })
            },

            selectRole( r ) {

                this.role = r;
                this.getData();
                
            },

            loadMore() {
                this.shouldConcat = true;
            }

        }

    }
</script>
